// PricingCard.js
import "./PricingCardStyles.css";
import { Link } from "react-router-dom";
import React from 'react';

const PricingCard = () => {
  return (
    <div className="pricing">
      <h1 className="section-title">What I can do</h1>
      <div className="card-container">

        <div className="card">
          <h3>UI Design</h3>
          <span className="bar"></span>
          <p>I create modern, clean, and responsive UI designs for websites or systems.</p>
          <p>Figma or live UI mockups included.</p>
          <Link to="/contact" className="btn">Request Design</Link>
        </div>

        <div className="card">
          <h3>Web Development</h3>
          <span className="bar"></span>
          <p>I develop beautiful and functional front-end websites using HTML, CSS, JavaScript, and React.</p>
          <p>Pixel-perfect and responsive layouts.</p>
          <Link to="/contact" className="btn">Build a Website</Link>
        </div>

        <div className="card">
          <h3>System Prototyping</h3>
          <span className="bar"></span>
          <p>I can turn your school or business system idea into a working front-end prototype.</p>
          <p>Best for capstone/system proposals.</p>
          <Link to="/contact" className="btn">Start a Prototype</Link>
        </div>

      </div>
    </div>
  )
}

export default PricingCard;
